import type { LucideIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { ActionButton } from '@/shared/ui/action-button';
import { Badge } from '@/components/ui/badge';
import { PopoverTrigger } from '@/components/ui/popover';

import type { DisplayContent } from '../model/types';

interface FilterTriggerProps {
  open: boolean;
  placeholder: string;
  icon?: LucideIcon;
  displayContent: DisplayContent;
}

export function FilterTrigger({ open, placeholder, icon: Icon, displayContent }: FilterTriggerProps) {
  const { t } = useTranslation();

  return (
    <PopoverTrigger asChild>
      <ActionButton
        intent="view"
        role="combobox"
        aria-expanded={open}
        className="w-auto justify-start text-left font-normal">
        {Icon && <Icon className="mr-2 h-4 w-4 text-muted-foreground" />}

        {displayContent.type === 'placeholder' && <span className="text-muted-foreground">{placeholder}</span>}

        {displayContent.type === 'all' && <span>{t('common.all', 'All items')}</span>}

        {displayContent.type === 'selected' && (
          <div className="flex items-center gap-1 flex-1 overflow-hidden">
            {displayContent.displayItems.map((name, index) => (
              <Badge key={index} variant="secondary" className="px-1.5 py-0">
                {name}
              </Badge>
            ))}
            {displayContent.remainingCount > 0 && (
              <Badge variant="secondary" className="px-1.5 py-0">
                +{displayContent.remainingCount}
              </Badge>
            )}
          </div>
        )}
      </ActionButton>
    </PopoverTrigger>
  );
}
